export enum ELinkManagementTabs {
  All = 'All',
  ManuallySubmitted = '2',
  GoogleImages = '3',
  GoogleWeb = '4',
  AtSource = '0',
}
